import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			totalCalories: '<loading data>'
		}
	}

	componentDidMount() {
		fetch(window.location.origin + window.location.pathname + 'gettotalcalorieunit', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.setState({ totalCalories: await response.text() })
			} else {
				this.setState({ smsError: await response.text() })
			}
		})
	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>We have checked all current authorizations for this patient requested by you and any other prescriber. The total calories currently authorized for this patient per day is: {this.state.totalCalories}</p>

				<p>You may begin a manual prior approval request if you are changing the patient’s Enteral order, or if more than 2500 calories per day is medically necessary.</p>

				<div className="button" onClick={() => this.props.navigate('R10')}>To prescribe a different number of calories per day, click here. </div>
				<div className="button" onClick={() => this.props.navigate('R13A')}>For instructions on how to begin a manual Prior Approval request, click here. </div>
			</div>
		);
	}
}